/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';

import Iconify from 'src/components/iconify';
import { UI } from 'src/features/transfer/constants';
import NewHeader from 'src/layouts/new-header/NewHeader';
import NewFooter from 'src/layouts/new-footer/NewFooter';
import TransactionStatusCard from 'src/components/Transaction-status-card/TransactionStatusCard';

// Client-only Transaction Status page.
// Reuses the SHARED TransactionStatusCard (admin=false) inside the new-design
// chrome. The original src/pages/TransactionStatus.jsx is left untouched and is
// still what the admin route (transaction/:id, admin) renders — so admin is
// unaffected.

export default function ClientTransactionStatus() {
  const navigate = useNavigate();
  const { id } = useParams();

  function handleBack() {
    navigate(-1);
  }

  return (
    <>
      <Helmet>
        <title>SafiSwap | Transaction</title>
      </Helmet>

      <Box
        sx={{
          bgcolor: UI.bg,
          color: UI.text,
          minHeight: '100vh',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: -200,
            left: -160,
            width: 1000,
            height: 1000,
            background: `radial-gradient(circle, ${UI.green}22 0%, transparent 60%)`,
            pointerEvents: 'none',
            zIndex: 0,
          },
          '& > *': {
            position: 'relative',
            zIndex: 1,
          },
        }}
      >
        <NewHeader />

        <Box component="main" sx={{ flexGrow: 1 }}>
          <Container maxWidth="lg" sx={{ pt: { xs: 3, md: 5 }, pb: { xs: 8, md: 10 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Button
                startIcon={<Iconify icon="mdi:arrow-left" width={22} />}
                onClick={handleBack}
                sx={{
                  fontWeight: 600,
                  borderRadius: 2,
                  px: 2,
                  py: 1,
                  textTransform: 'none',
                  color: UI.text,
                  border: `1px solid ${UI.border}`,
                  bgcolor: 'rgba(255,255,255,0.03)',
                  boxShadow: 'none',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.06)' },
                }}
              >
                Back
              </Button>
              <Box flexGrow={1} />
            </Box>

            <TransactionStatusCard id={id} admin={false} />
          </Container>
        </Box>

        <NewFooter />
      </Box>
    </>
  );
}
